import { BracketSeries, GameId } from "@portal-frontend-ssr/blast-api";
import { BracketProps } from "../shared/types/interfaces";
import { Link } from "@remix-run/react";
import { generateMatchPageUrl } from "~/shared/helpers/url/generateMatchPageUrl";

export const MatchGrid = ({
  gameId,
  tournamentName,
  matches,
}: {
  gameId: GameId;
  tournamentName: string;
  matches: BracketSeries[];
}) => {
  return (
    <div className="mt-3 flex flex-wrap gap-3">
      {matches.map((match) => {
        const teams = [
          match.teamA ? { ...match.teamA, score: match.teamAScore } : null,
          match.teamB ? { ...match.teamB, score: match.teamBScore } : null,
        ];

        return (
          <Link
            key={match.uuid}
            to={
              generateMatchPageUrl({
                game: gameId,
                tournamentName,
                matchName: match.name,
                matchUuid: match.uuid,
                teamAName: match.teamA?.name ?? "",
                teamBName: match.teamB?.name ?? "",
              }) ?? ""
            }
          >
            <div className="flex min-w-24 max-w-28 flex-col">
              <div className="truncate font-style-label-l4" title={match.name}>
                {match.name}
              </div>
              <div className="mt-2 flex flex-col gap-1 rounded-small border-4 border-background-80 bg-background-80 font-style-body-b4">
                {teams.map((team, index) => {
                  if (!team?.name) {
                    return (
                      <div className="truncate rounded-small bg-background-100 p-2 text-center" key={index}>
                        {team?.name ?? "???"}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="flex justify-between gap-1 rounded-small bg-background-100 p-2 text-center"
                        title={team.name}
                        key={index}
                      >
                        <span className="truncate">{team.name}</span>
                        {team && !match.isCompleted && !match.isLive && <span>-</span>}
                        {team && (match.isCompleted || match.isLive) && <span>{team.score}</span>}
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export const SingleElim32Bounty = ({ bracket, gameId }: BracketProps) => {
  if (!bracket.matches) return null;

  return (
    <div className="relative w-full">
      <div className="custom-scrollbar relative overflow-x-auto pb-4">
        <div className="flex w-full justify-center bg-background-95 p-1">
          <p className="font-style-label-l4">Round of 32</p>
        </div>
        <MatchGrid
          gameId={gameId}
          tournamentName={bracket.parentTournamentName ?? bracket.tournamentName}
          matches={bracket.matches.slice(0, 16)}
        />

        <div className="mt-5 flex w-full justify-center bg-background-95 p-1">
          <p className="font-style-label-l4">Round of 16</p>
        </div>
        <MatchGrid
          gameId={gameId}
          tournamentName={bracket.parentTournamentName ?? bracket.tournamentName}
          matches={bracket.matches.slice(16, 24)}
        />
      </div>
    </div>
  );
};
